export const docStatus = {
  AUTHORIZED: 1,
  CANCELED: 2,
  UNUTILIZED: 3,
  SALE: 1,
  PURCHASE: 0,
}



// WEBPACK FOOTER //
// ./src/public/api/docStatus.js